export const MyProfileSubpageButtonLabels = {
  MY_PROFILE: 'MY PROFILE',
  SEARCH_ALERTS: 'SEARCH ALERTS',
  CREATE_SEARCH_ALERTS: 'CREATE SEARCH ALERT',
  EDIT_SEARCH_ALERTS: 'EDIT SEARCH ALERT',
  NOTIFICATIONS: 'NOTIFICATIONS',
};
